import { Drawing } from "drawing";
import { edgeOffsetPoint } from "../geometry/edge-offset-center.js";

export function edgeOffset(fab, instance, edges) {
  const edge = edges[instance.reference.loop]?.[instance.reference.edge];

  const { center } = edgeOffsetPoint(edge, instance.reference);

  const pt = new Drawing()
    .point(center, "circle-crosshairs")
    .style({ stroke: "red", fill: "transparent" });

  return {
    point: center,
    path: null,
    voids: [],
    dims: () => [],
    annotations: pt,
  };
}
